import { render } from "./TheHeader.vue?vue&type=template&id=26a1239e&scoped=true"
const script = {}

import "./TheHeader.vue?vue&type=style&index=0&id=26a1239e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26a1239e"]])

export default __exports__